import { cn } from '@shared/lib/utils'

import { clientBadgeVariants } from './variants'

import type { VariantProps } from 'class-variance-authority'

export interface IClientBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof clientBadgeVariants> {
  color?: 'error' | 'warning' | 'success' | 'primary-500' | 'primary-950' | 'info' | 'submitted'
}

export default function ClientBadge({
  style,
  variant,
  className,
  color = 'primary-500',
  ...props
}: IClientBadgeProps) {
  return (
    <span
      className={cn(clientBadgeVariants({ variant }), className)}
      style={
        {
          '--color-client-primary': `hsl(var(--client-${color}))`,
          '--color-client-secondary': `color-mix(in srgb, hsl(var(--client-${color}) / 10%) , transparent)`,
          ...style,
        } as React.CSSProperties
      }
      {...props}
    />
  )
}
